import React, { useState } from 'react'
import { useProject } from '@/modules/work/projects/context';
import { DISCORD } from "icons";
import { EvtIntegrationInputCard } from "components/project/integration/inputcard";
import { useChannelMutation } from '../../mutation';
import CreateChannelDialog from './input';
import { useDiscordData } from './useDiscordData';

export default function DiscordIntegration({ project_slug }) {

    const { id } = useProject();
    const { discordChannelIds } = useDiscordData(id);

    const [showChannelDialog, setShowChannelDialog] = useState(false);
    const { mutate: createchannelMutate, isPending: isCreatingChannel } = useChannelMutation();
    const handleChannelCreation = async () => {
        const payload = {
            id,
        };
        await createchannelMutate({ values: payload });
        setShowChannelDialog(false);
    };

    const hasAny = discordChannelIds.length > 0

    return (
        <div>
            <EvtIntegrationInputCard
                title={"Discord"}
                icon={DISCORD}
                type={"Channel"}
                onClick={() => setShowChannelDialog(true)}
                disabled={hasAny}
            />
            <CreateChannelDialog
                open={showChannelDialog}
                onOpenChange={setShowChannelDialog}
                onConfirm={handleChannelCreation}
                isLoading={isCreatingChannel}
                project={project_slug}
            />
        </div>
    )
}